import React from "react";
import EditTenant from "./EditTenant";
import Modal from "../../../Ui/Modal";
import BodyHeader from "../BodyHeader";
import Menu from "assets/icons/Menu.svg";
import { Toaster } from "react-hot-toast";
import AddPropertyForm from "./AddProperty";
import ViewDetails from "./PropertyDetails";
import AddTenantForm from "./AddTenantForm";
import PropertiesCard from "./PropertiesCard";
import PlusIcon from "assets/icons/Plus.svg";
import SearchBar from "../SearchBarActivities";
import { Property } from "../../../../service";
import AddFamilyMember from "./AddFamilyMember";
import CircularLoader from "../../../Ui/Loader";
import Building from "assets/icons/Building.svg";
import BookMark from "assets/icons/BookMark.svg";
import ButtonComponent from "../../../Ui/Button";
import FamilyInvitation from "./FamilyInvitation";
import EmptyActivities from "../EmptyActivities";
import TenantsInvitation from "./TenantsInvitation";
import useApiHandler from "../../../hooks/ApiHandler";
import PropertyImage from "assets/images/Property.png";
import { useState, useEffect, useContext } from "react";
import ManageJobComponent from "../ModalData/ManageJob";
import CancelJobComponent from "../ModalData/CancelJob";
import { UserContext } from "../../../context/UserContext";
import { useStatisticsData } from "../../../context/StatisticsData";
import CanceledConfirmationComponent from "../ModalData/CanceledConfirmation";
import CustomPagination from "../Pagination";
import EditFamily from "./EditFamily";

const Properties = () => {
  const { userData } = useContext(UserContext);
  const { callApi, loading } = useApiHandler();
  const [modalState, setModalState] = useState("");
  const [tenants, setTenants] = useState([]);
  const [familyInviteMembers, setFamilyInviteMembers] = useState([]);
  const [property, setProperty] = React.useState([]);
  const [currentSelectedData, setCurrentSelectedData] = useState({});
  const [propertyId, setPropertyId] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [propertySearch, setPropertySearch] = useState("");
  const { refreshStatistics } = useStatisticsData();
  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [deleteConfirm, setDeleteConfirm] = useState({
    show: false,
    propertyId: null,
    propertyName: "",
  });

  const modalConfig = {
    viewDetails: () => (
      <ViewDetails
        setModalState={setModalState}
        propertyId={propertyId}
        property={property}
        setCurrentSelectedData={setCurrentSelectedData}
        setPropertyId={setPropertyId}
      />
    ),
    editTenant: () => (
      <EditTenant
        setModalState={setModalState}
        propertyId={propertyId}
        setPropertyId={setPropertyId}
      />
    ),
    addTenant: () => (
      <AddTenantForm
        setTenantsInfo={setTenants}
        tenantsInfo={tenants}
        setModalState={setModalState}
        propertyId={propertyId}
        setPropertyId={setPropertyId}
        onSuccess={() => {
          fetchProperties();
          setTenants([]);
        }}
      />
    ),
    addProperty: () => (
      <AddPropertyForm
        setModalState={setModalState}
        onSuccess={fetchProperties}
        setPropertyId={setPropertyId}
        propertyId={propertyId}
      />
    ),
    tenantsInvitation: () => (
      <TenantsInvitation
        tenantsInfo={tenants}
        setModalState={setModalState}
        propertyId={propertyId}
        setPropertyId={setPropertyId}
        onSuccess={() => {
          fetchProperties();
          setTenants([]);
        }}
      />
    ),
    manageJobs: () => (
      <ManageJobComponent
        setModalState={setModalState}
        currentSelectedData={currentSelectedData}
      />
    ),
    cancelJob: () => <CancelJobComponent setModalState={setModalState} />,
    canceledConfirmation: () => (
      <CanceledConfirmationComponent setModalState={setModalState} />
    ),
    // propertyId: () => (
    //   <AddPropertyForm
    //     propertyId={propertyId.id}
    //     setModalState={setModalState}
    //     property={propertyId}
    //     onSuccess={fetchProperties}
    //   />
    // ),
    addFamilyMember: () => (
      <AddFamilyMember
        setModalState={setModalState}
        propertyId={propertyId}
        property={propertyId}
        onSuccess={(payload) => {
          // Save members and open invitation modal
          const members = payload?.familyMembers || [];
          setFamilyInviteMembers(members);
          setModalState("familyInvitation");
        }}
      />
    ),
    editFamily: () => (
      <EditFamily
        setModalState={setModalState}
        propertyId={propertyId}
        setPropertyId={setPropertyId}
        onInvite={(members) => {
          setFamilyInviteMembers(members);
          setModalState("familyInvitation");
        }}
      />
    ),
    familyInvitation: () => (
      <FamilyInvitation
        setModalState={setModalState}
        propertyId={propertyId}
        property={propertyId}
        onSuccess={() => {
          fetchProperties();
          setFamilyInviteMembers([]);
        }}
        familyMembers={familyInviteMembers}
      />
    ),
  };

  const renderModal = () => {
    const ModalComponent = modalConfig[modalState];
    return ModalComponent ? ModalComponent() : null;
  };

  const fetchProperties = (searchQuery = propertySearch) => {
    if (userData) {
      console.log(
        `Fetching properties - Page: ${currentPage}, Limit: ${resultsPerPage}, Search: ${searchQuery}`
      );
      callApi(
        () =>
          Property.getProperties(
            userData.id,
            currentPage,
            resultsPerPage,
            searchQuery
          ),
        {
          onSuccess: (res) => {
            console.log("Properties API Response:", res.data);
            // Handle paginated response structure
            if (res.data) {
              setProperty(res.data?.results);
              setTotalCount(res.data.count);
              console.log(
                `Total count: ${res.data.count}, Results: ${res.data.results.length}`
              );
            } else {
              // Fallback for non-paginated response
              setProperty(res.data);
              setTotalCount(res.data?.length);
            }
          },
          onError: (error) => {
            console.error("Error fetching properties:", error);
          },
          errorMessage: "Failed to fetch properties",
        }
      );
    }
  };

  const handleDeleteClick = (id, propertyName) => {
    setDeleteConfirm({ show: true, propertyId: id, propertyName });
    setOpenDropdownId(null);
  };

  const handleConfirmDelete = () => {
    if (deleteConfirm.propertyId) {
      callApi(() => Property.deleteProperties(deleteConfirm.propertyId), {
        onSuccess: (res) => {
          fetchProperties();
          closeDeleteConfirm();
          refreshStatistics();
        },
        onError: (error) => {
          console.error("Error deleting property:", error);
        },
      });
    }
  };

  const closeDeleteConfirm = () => {
    setDeleteConfirm({ show: false, propertyId: null, propertyName: "" });
  };

  const toggleDropdown = (cardId) => {
    setOpenDropdownId(openDropdownId === cardId ? null : cardId);
  };

  // Handle search with debouncing
  const handleSearch = (searchValue) => {
    setPropertySearch(searchValue);
    setCurrentPage(1); // Reset to first page when searching
  };

  const handleAddProperty = () => {
    setTenants([]);
    setPropertyId(null);
    setModalState("addProperty");
  };

  useEffect(() => {
    if (userData) {
      fetchProperties();
    }
  }, [userData, currentPage, resultsPerPage]);

  // Listen for global properties:refresh events so lists update immediately after adding
  useEffect(() => {
    const onRefresh = (e) => {
      // Optionally jump to first page to ensure the new property shows up
      // but keep current pagination for minimal disruption
      fetchProperties();
    };
    window.addEventListener("properties:refresh", onRefresh);
    return () => window.removeEventListener("properties:refresh", onRefresh);
  }, [propertySearch, currentPage, resultsPerPage, userData]);

  const handleResultsPerPageChange = (newResultsPerPage) => {
    setResultsPerPage(newResultsPerPage);
    setCurrentPage(1);
  };
  console.log(property, "property");
  return (
    <>
      <Toaster />
      {loading ? (
        <CircularLoader minHeight="400px" />
      ) : (
        <div className="flex flex-col">
          {renderModal()}

          <div className="flex flex-col md:gap-8 gap-6 md:py-8 py-6">
            <BodyHeader
              title="My Properties"
              description="All the properties you manage in one place. Add new addresses, edit existing ones, and monitor job activity by property."
            >
              <button
                onClick={handleAddProperty}
                className="bg-[#3cab5c] flex gap-2 items-center justify-center h-12 text-nowrap w-fit hover:bg-[#3c8f47] text-white px-3 sm:text-[14px] lg:text-[16px] py-3 rounded-xl font-medium"
              >
                <img src={PlusIcon} className="w-[14px] h-[14px]" alt="Plus" />
                Add Property
              </button>
            </BodyHeader>

            <SearchBar
              label="Search job"
              placeholder="Search by property, street, or city"
              select={[{ label: "Sort by", values: ["A", "B", "C"] }]}
              onSearch={handleSearch}
            />
          </div>

          <div>
            {property.length ? (
              <div className="w-full md:py-4 py-2">
                <Modal
                  open={deleteConfirm.show}
                  onClose={closeDeleteConfirm}
                  title="Confirm Delete"
                  footer={
                    <div className="w-full flex justify-end gap-4">
                      <ButtonComponent onClick={closeDeleteConfirm}>
                        Cancel
                      </ButtonComponent>
                      <ButtonComponent
                        bgColor="#D40000"
                        color="#fff"
                        onClick={handleConfirmDelete}
                      >
                        Delete
                      </ButtonComponent>
                    </div>
                  }
                >
                  {" "}
                  <p className="text-[#595959] text-[24px] py-10 font-medium text-center m-auto r mb-6 max-w-[350px]">
                    Are you sure you want to delete {deleteConfirm.propertyName}
                    ? This action cannot be undone.
                  </p>
                </Modal>

                <PropertiesCard
                  totalCount={totalCount}
                  btnText="Post job at this address"
                  offers={property}
                  setOpen={setModalState}
                  onRefresh={fetchProperties}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  resultsPerPage={resultsPerPage}
                  onResultsPerPageChange={handleResultsPerPageChange}
                >
                  {(offer, cardId) => (
                    <div className="flex justify-between">
                      <div className="bg-[#ECEEF2] p-3 rounded-[8px]">
                        <img
                          src={Building}
                          alt="Building"
                          className="w-5 h-5 rounded-full"
                        />
                      </div>
                      <div className="relative flex gap-4">
                        {/*<img*/}
                        {/*  className="w-6 h-6"*/}
                        {/*  src={BookMark}*/}
                        {/*  alt="Bookmark"*/}
                        {/*/>*/}
                        <img
                          onClick={() => toggleDropdown(cardId)}
                          className="w-6 h-6 cursor-pointer"
                          src={Menu}
                          alt="Menu"
                        />
                        {openDropdownId === cardId && (
                          <div className="absolute right-0 top-8 z-10 bg-white border border-gray-200 rounded shadow-md w-32">
                            <button
                              className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                              onClick={() => {
                                setPropertyId(offer.id);
                                setModalState("viewDetails");
                                setOpenDropdownId(null);
                              }}
                            >
                              View Details
                            </button>
                            <button
                              className="block w-full text-left px-4 py-2 hover:bg-gray-100"
                              onClick={() => {
                                setPropertyId(offer.id);
                                setModalState("addProperty");
                                setOpenDropdownId(null);
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600"
                              onClick={() =>
                                handleDeleteClick(
                                  offer.id,
                                  offer.name || offer.propertyTitle
                                )
                              }
                            >
                              Delete
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </PropertiesCard>
              </div>
            ) : (
              <EmptyActivities
                label="You haven't added any properties yet."
                description="Start by adding an address you manage to streamline job posting and contractor matching."
                img={PropertyImage}
                buttonLabel="Add first property"
                onButtonClick={handleAddProperty}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Properties;
